import AbaTypeEnum from '~Api/WarehouseLoanTransactionAba/AbaTypeEnum';
import { IDictionary } from '~utilities/IDictionary';

const abaTypeLabels: IDictionary<string> = {
    [AbaTypeEnum.Fwt1SellInPrepaidInterest]: 'FWT1',
    [AbaTypeEnum.Fwt2SellInPrepaidInterest]: 'FWT2',
};

export default abaTypeLabels;